//Use CommonJS style via browserify to load other modules
require("./social");
require("./ads");
require("component-responsive-frame/child");

var $ = require("./lib/jquery/dist/jquery.min");

$(".button").click(function(){
    $(".images").toggle();
});